export const teamSmartImagesEntitiesSelector = state =>
  state.entities.teamSmartImages;

export const teamSmartImageSelector = ({ state, mediaId }) =>
  state.entities.teamSmartImages[mediaId];
